import { Moment } from 'moment'
import React from 'react'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import { SHORT_DAY_NAME_DAY_MONTH_YEAR } from 'constants/dateFormats'
import { useRegionTimeFormat } from 'hooks/useRegionTimeFormat'

const DateTime = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: flex-start;
`

const Date = styled.div`
  flex: 1;
`
const Time = styled.div`
  flex: 1;
`

type Props = {
  date?: Moment
  time?: Moment
  day?: number
}

function SummaryDateTime({ date, time, day }: Props) {
  const timeFormat = useRegionTimeFormat()

  if (!date && !time && !day) return null

  return (
    <DateTime>
      {day && (
        <Date>
          <BodyText weight="bold" variant="medium">
            Day
          </BodyText>
          <BodyText variant="large">Day {day}</BodyText>
        </Date>
      )}
      {!day && date && (
        <Date>
          <BodyText weight="bold" variant="medium">
            Date
          </BodyText>
          <BodyText variant="large">
            {date?.format(SHORT_DAY_NAME_DAY_MONTH_YEAR)}
          </BodyText>
        </Date>
      )}
      {time && (
        <Time>
          <BodyText weight="bold" variant="medium">
            Time
          </BodyText>
          <BodyText variant="large">{time?.format(timeFormat)}</BodyText>
        </Time>
      )}
    </DateTime>
  )
}

export default SummaryDateTime
